export const COMPANY_INFO_HEADER_MARGIN = 36;
